import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoObjectGisChildM(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 2C2.77614 2 3 2.20664 3 2.46154L3 13.5385C3 13.7934 2.77614 14 2.5 14C2.22386 14 2 13.7934 2 13.5385L2 2.46154C2 2.20664 2.22386 2 2.5 2Z"
        fill="#97B2C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 2C4.77614 2 5 2.20664 5 2.46154L5 13.5385C5 13.7934 4.77614 14 4.5 14C4.22386 14 4 13.7934 4 13.5385L4 2.46154C4 2.20664 4.22386 2 4.5 2Z"
        fill="#97B2C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.50832 2.20836C8.66444 1.99526 8.98386 1.93587 9.22176 2.07572L14 4.88464L9.87815 7.3077L12.8223 9.03845L9.87815 10.7692L12.2335 12.1538L9.22176 13.9243C8.98386 14.0641 8.66444 14.0047 8.50832 13.7916C8.3522 13.5785 8.41849 13.2924 8.65639 13.1525L10.3553 12.1538L8 10.7692L10.9442 9.03845L8 7.3077L12.1218 4.88464L8.65639 2.84745C8.41849 2.7076 8.3522 2.42147 8.50832 2.20836Z"
        fill="#EB3333"
      />
    </svg>
  )
}
export const IconGeoObjectGisMain = createIcon({
  l: IconGeoObjectGisChildM,
  m: IconGeoObjectGisChildM,
  s: IconGeoObjectGisChildM,
  xs: IconGeoObjectGisChildM,
  name: 'IconGeoObjectGisMain',
})
